import './scss/index.scss';
import BlockSpinner from './js/block-spinner';

export {
    BlockSpinner
};
